export const messages = {
  page: {
    title: {
      id: 'treatmentSummary.Title',
      defaultMessage: 'Treatment Summary',
    },
    noTreatmentSummaryItems: {
      id: 'treatmentSummary.NoItemsToDisplay',
      defaultMessage: 'No items to display',
    },
    moreLink: {
      id: 'treatmentSummary.Page.MoreLink',
      defaultMessage: 'More...',
    },
    lessLink: {
      id: 'treatmentSummary.Page.LessLink',
      defaultMessage: 'Less...',
    },
    new: {
      id: 'treatmentSummary.New',
      defaultMessage: 'New',
    },
  },
  groups: {
    Allergy: {
      id: 'treatmentSummary.Groups.Allergy.Title',
      defaultMessage: 'ALLERGIES',
    },
    Chemotherapy: {
      id: 'treatmentSummary.Groups.Chemotherapy.Title',
      defaultMessage: 'CHEMOTHERAPY',
    },
    ClinicalTrial: {
      id: 'treatmentSummary.Groups.ClinicalTrial.Title',
      defaultMessage: 'CLINICAL TRIALS',
    },
    Comorbidity: {
      id: 'treatmentSummary.Groups.Comorbidity.Title',
      defaultMessage: 'OTHER MEDICAL CONDITIONS',
    },
    Diagnosis: {
      id: 'treatmentSummary.Groups.Diagnosis.Title',
      defaultMessage: 'DIAGNOSIS',
    },
    FamilyHistory: {
      id: 'treatmentSummary.Groups.FamilyHistory.Title',
      defaultMessage: 'RELEVANT FAMILY HISTORY',
    },
    GeneticTest: {
      id: 'treatmentSummary.Groups.GeneticTest.Title',
      defaultMessage: 'GENETICS',
    },
    GynecologicHistory: {
      id: 'treatmentSummary.Groups.GynecologicHistory.Title',
      defaultMessage: 'GYNECOLOGIC HISTORY',
    },
    InitialClinicalFinding: {
      id: 'treatmentSummary.Groups.InitialClinicalFinding.Title',
      defaultMessage: 'INITIAL CLINICAL FINDINGS',
    },
    HormoneTherapy: {
      id: 'treatmentSummary.Groups.HormoneTherapy.Title',
      defaultMessage: 'HORMONE THERAPY',
    },
    Other: {
      id: 'treatmentSummary.Groups.Other.Title',
      defaultMessage: 'OTHER',
    },
    RadiationTherapy: {
      id: 'treatmentSummary.Groups.RadiationTherapy.Title',
      defaultMessage: 'RADIATION THERAPY',
    },
    SideEffectBundle: {
      id: 'treatmentSummary.Groups.SideEffectBundle.Title',
      defaultMessage: 'PERSISTENT SIDE EFFECTS',
    },
    SocialHistory: {
      id: 'treatmentSummary.Groups.SocialHistory.Title',
      defaultMessage: 'SOCIAL HISTORY',
    },
    Surgery: {
      id: 'treatmentSummary.Groups.Surgery.Title',
      defaultMessage: 'SURGERY',
    },
    TransplantHistory: {
      id: 'treatmentSummary.Groups.TransplantHistory.Title',
      defaultMessage: 'TRANSPLANT HISTORY',
    },
    TumorMarker: {
      id: 'treatmentSummary.Groups.TumorMarker.Title',
      defaultMessage: 'TUMOR MARKER',
    },
  },
};
